import { createSlice } from "@reduxjs/toolkit";

const ProductFilter = createSlice({
  name: "ProductFilter",
  initialState: {
    location: "",
    color: [],
    condition: "Brand New",
    price: [],
    minimumOrder: 0,
    category: [],
    navCategory: "",
  },
  reducers: {
    addColor: (state, action) => {
      state.color.push(action.payload);
    },
    //  add Price and remove Price dispatch
    addPrice: (state, action) => {
      state.price.push(action.payload);
    },
    removePrice: (state, action) => {
      state.price = state.price.filter((price) => price !== action.payload);
    },
    /* add Price and remove Price dispatch ends */

    //  add color and remove color dispatch
    addColor: (state, action) => {
      state.color.push(action.payload);
    },
    removeColor: (state, action) => {
      state.color = state.color.filter((color) => color !== action.payload);
    },
    /* add color and remove color dispatch */

    // add minimum Order
    addMminimumOrder: (state, action) => {
      state.minimumOrder = action.payload;
    },

    /* add condition*/
    addCondition: (state, action) => {
      state.condition = action.payload;
    },

    /* AddLocation */
    addLocation: (state, action) => {
      state.location = action.payload;
    },

    /* Add category */
    addCategory: (state, action) => {
      state.category.push(action.payload);
    },
    removeCategory: (state, action) => {
      state.category = state.category.filter(
        (category) => category !== action.payload
      );
    },
    addNavCategory: (state, action) => {
      state.navCategory = action.payload;
    },
  },
});

export const {
  addPrice,
  removePrice,
  addColor,
  removeColor,
  addMminimumOrder,
  addCondition,
  addLocation,
  addCategory,
  removeCategory,
  addNavCategory,
} = ProductFilter.actions;
export default ProductFilter.reducer;
